import { Badge, Flex, Text } from '@chakra-ui/react';
import { ImageWithSkeleton } from 'features/common/components/ImageWithSkeleton';
import { SitecoreContextResourceType } from 'features/context-ids/types/types';
import { validResources } from 'features/context-ids/utils';

export const generateResourcesTableData = (
  resources?: SitecoreContextResourceType[],
) =>
  resources?.map(({ name, tenantDisplayName, tenantProductCode, type }) => ({
    name,
    tenantDisplayName,
    tenantProductCode,
    type,
  })) ?? [];

const renderAppCell = ({
  tenantProductCode,
  name,
  type,
}: Partial<SitecoreContextResourceType>) => {
  const { iconUrl, name: displayName } =
    validResources[
      tenantProductCode?.toLowerCase() as keyof typeof validResources
    ] ?? {};
  const isEdge = tenantProductCode === 'Edge';

  return (
    <Flex gap={2} alignItems='center'>
      <ImageWithSkeleton
        key={displayName}
        width='7'
        height='7'
        src={iconUrl}
        alt={displayName}
        flexShrink={0}
      />
      <Flex alignItems='center' gap={2}>
        <Text>{name}</Text>
        <Badge
          hidden={type !== 'edge'}
          textTransform='capitalize'
          colorScheme={isEdge ? 'success' : 'neutral'}
        >
          {isEdge ? 'live' : 'preview'}
        </Badge>
      </Flex>
    </Flex>
  );
};

export const columns = [
  {
    id: 'name',
    Header: 'Resources',
    accessor: renderAppCell,
    disableSortBy: true,
  },
  {
    id: 'resource',
    Header: 'Tenant',
    accessor: 'tenantDisplayName',
    disableSortBy: true,
  },
];
